import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { FormArray, FormGroup, FormGroupDirective } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { SpecLine } from 'src/app/features/asset-management/models/SpecLine';
import { fillLimit, generateSpecLineFromFormGroup } from '../../utils/SpecificationUtils';
import { TranslationService } from '../../../../shared/translations/services/translation.service';

@Component({
  selector: 'app-create-cam-spec-line',
  templateUrl: './create-cam-spec-line.component.html',
  styleUrls: ['./create-cam-spec-line.component.scss'],
  standalone: false
})
export class CreateCamSpecLineComponent implements OnInit, OnDestroy {
  private readonly ngUnsubscribe = new Subject<void>();
  specificationLineForm: FormGroup;

  specline: SpecLine = undefined;
  lineName: string;
  lineIndex = 0;

  secondRepairLimitExists = false;

  editMode = true;
  isDefault = true;

  private readonly route = inject(ActivatedRoute);
  private readonly formGroupDirective = inject(FormGroupDirective);
  protected translationService = inject(TranslationService);

  constructor() {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.lineIndex = +params['specificationLineIndex'];
      this.specificationLineForm = (this.formGroupDirective.control.get('lines') as FormArray).at(this.lineIndex) as FormGroup;

      this.specline = generateSpecLineFromFormGroup(this.specificationLineForm.value);
      this.lineName = this.specificationLineForm.get('lineName').value;
      this.secondRepairLimitExists = this.specificationLineForm.get('secondRepairLimitAdded').value;
      this.isDefault = this.specificationLineForm.get('isDefault').value;
    });
  }

  addRepairLimit() {
    this.secondRepairLimitExists = true;
    this.specificationLineForm.patchValue({ secondRepairLimitAdded: true });
    this.specline.limits.push(fillLimit(this.specificationLineForm.value.limit1));
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
